import editor from './editor.vue'

const common = {
	install:function(Vue){
		Vue.component('editor',editor)
	}
}

export default common